import * as React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import CursorFollowTooltip from '~/client/src/shared/components/CursorFollowTooltip/CursorFollowTooltip'
import {
  LINK_UNDERLINE_ON_GROUP_HOVER,
  ObjectReference,
} from '~/client/src/shared/components/ObjectReference/ObjectReference'
import { StackedReference } from '~/client/src/shared/components/ObjectReference/StackedReference'
import { HOVER_CARD_POPUP_CLASS } from '~/client/src/shared/components/ResourceLink/ResourceValueReference'
import PermitCard from '~/client/src/shared/components/SitemapCards/PermitCard'
import WorkflowTypeIcon from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowTypeIcon'
import Workflow from '~/client/src/shared/models/Workflow'

// localization: no text to translate

interface IProps {
  workflow: Workflow
  onClick?: (workflow: Workflow) => void
}

const LinkedWorkflowItem: React.FC<IProps> = observer(
  ({ workflow, onClick }) => {
    const { workflowTypesStore, isMobileEnv } = React.useContext(
      MobXProviderContext,
    ) as any

    const permitType = workflowTypesStore?.getPermitTypeById(workflow.typeId)
    const title = workflow.getCaption(workflowTypesStore, true)

    const tooltipContent = React.useMemo(
      () => (
        <div className="tw:w-[350px]">
          <PermitCard permit={workflow} />
        </div>
      ),
      [workflow],
    )

    const reference = (
      <StackedReference
        size="dense"
        secondLine={workflow.code}
        reference={
          <ObjectReference
            icon={
              <WorkflowTypeIcon iconName={permitType?.iconName} size="small" />
            }
            variant="plain"
            size="dense"
          >
            <span title={title} className={LINK_UNDERLINE_ON_GROUP_HOVER}>
              {title}
            </span>
          </ObjectReference>
        }
      />
    )

    const item = onClick ? (
      <span
        role="button"
        tabIndex={0}
        className="tw:group/value tw:inline-flex tw:max-w-full tw:cursor-pointer"
        onClick={() => onClick(workflow)}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onClick(workflow)
          }
        }}
      >
        {reference}
      </span>
    ) : (
      <span className="tw:inline-flex tw:max-w-full">{reference}</span>
    )

    // On touch a tap would open the preview and leave it stuck over what the tap opens.
    return isMobileEnv ? (
      item
    ) : (
      <CursorFollowTooltip
        content={tooltipContent}
        // PermitCard already pads 12px; this tops it up to the 16px of the resource card.
        portalClassName={`${HOVER_CARD_POPUP_CLASS} tw:p-1`}
      >
        {item}
      </CursorFollowTooltip>
    )
  },
)

export default LinkedWorkflowItem
